import { IJsonQueryDateRangeValue } from '../../api-models/common/json_query';

export function isJsonQueryDatesSimilar(a: IJsonQueryDateRangeValue | null, b: IJsonQueryDateRangeValue | null) {
  if (a === b) {
    return true;
  }

  return a && b && a.gte === b.gte && a.lt === b.lt;
}
